import styled from 'styled-components';
import { rem } from 'polished';

const UseToolsHorizontalScrollContainer = styled.div`
    margin: ${rem(8)} -${({ theme }) => rem(theme.modal.padding.h)};
`;

export default UseToolsHorizontalScrollContainer;
